import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=0adb1c90&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb1c90",
  null
  
)

export default component.exports